var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E10092",
    d: "M19.748,18.567l-5.738-5.742c1.131-1.356,1.812-3.091,1.812-4.984c0-4.32-3.546-7.833-7.907-7.833 S0,3.525,0,7.845c0,4.32,3.545,7.833,7.907,7.833c1.853,0,3.558-0.635,4.91-1.697l5.76,5.76c0.336,0.336,0.836,0.336,1.172,0 S20.084,18.903,19.748,18.567z M1.681,7.845c0-3.394,2.795-6.152,6.226-6.152c3.431,0,6.226,2.758,6.226,6.152 c0,3.393-2.795,6.153-6.226,6.153C4.476,13.998,1.681,11.234,1.681,7.845z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.cbd27054b1fa310830ee278bebaff944.svg";
export { ForwardRef as ReactComponent };